var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colunaIcone"},[(_vm.consultaConfirmada)?_c('i',{staticClass:"el-icon-circle-check"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }